export const ACCOUNTS_COLUMN_WIDTH_COLLAPSED = 120
